import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import Icon from './Icon';

const StyledIcon = styled(Icon)`
  fill: none;
`;

const CheckboxFilled = (props) => {
  const { tickColor, boxColor, boxBorderColor, boxBorderWidth, ...restProps } =
    props;
  return (
    // eslint-disable-next-line react/jsx-props-no-spreading
    <StyledIcon {...restProps} viewBox="0 0 24 24">
      <rect
        x="2"
        y="2"
        width="20"
        height="20"
        rx="4"
        fill={boxColor}
        stroke={boxBorderColor}
        strokeWidth={boxBorderWidth}
      />
      <path
        d="M7.94921 12.1949L8.14059 12.0214L7.94921 12.1949L10.5092 15.0185C10.7992 15.3383 11.2808 15.3383 11.5708 15.0185L16.0508 10.0773C16.3275 9.77208 16.3275 9.28675 16.0508 8.98154C15.7608 8.66171 15.2792 8.66171 14.9892 8.98154L11.04 13.3373L9.01079 11.0992C8.72081 10.7794 8.23919 10.7794 7.94921 11.0992C7.67249 11.4044 7.67249 11.8897 7.94921 12.1949Z"
        fill={tickColor}
        stroke={tickColor}
        strokeWidth="0.516667"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </StyledIcon>
  );
};

CheckboxFilled.propTypes = {
  tickColor: PropTypes.string,
  boxColor: PropTypes.string,
  boxBorderColor: PropTypes.string,
  boxBorderWidth: PropTypes.string
};

CheckboxFilled.defaultProps = {
  tickColor: 'white',
  boxColor: 'var(--color-i-green)',
  boxBorderColor: 'none',
  boxBorderWidth: '1px'
};

export default CheckboxFilled;
